import type { ArrayElement, StudentState as StudentStateType } from '@evidia/shared';
import type { PresetColorType } from 'antd/es/_util/colors';
import type { LiteralUnion } from 'antd/lib/_util/type';
import { STUDENT_STATE_TEXT } from '../const/const';
import type { RouterOutput } from '../utils/trcp';
import StyledTag from './Styled/Tag';

type StudentStateTypePrismaType = ArrayElement<RouterOutput['student']['students']>['state'];

const COLOR_MAP: Record<
	StudentStateType,
	LiteralUnion<PresetColorType | 'success' | 'processing' | 'error' | 'default' | 'warning'>
> = {
	EXAM_CORRECTION: 'volcano',
	FINISHED: 'black',
	IN_PROGRESS: 'blue',
	NOT_STARTED: 'red',
	TO_EXAM: 'orange',
	STORNO: 'volcano-inverse',
	DONE: 'green',
	WAITING_FOR_ADMISSION: 'orange-inverse',
};

interface Props {
	state: StudentStateType | StudentStateTypePrismaType;
	tag?: boolean;
}

const StudentState: React.FC<Props> = ({ state, tag = true }) => {
	if (tag) {
		return <StyledTag color={COLOR_MAP[state]}>{STUDENT_STATE_TEXT[state]}</StyledTag>;
	}

	return <>{STUDENT_STATE_TEXT[state]}</>;
};

export default StudentState;
